module.exports = __webpack_public_path__ + "img/Bahamas.f93e5d81.png";